/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PromotionCodeInvalidReason = {
    InvalidCode: 'INVALID_CODE',
    Expired: 'EXPIRED',
    NotYetValid: 'NOT_YET_VALID',
} as const;
export type PromotionCodeInvalidReason = typeof PromotionCodeInvalidReason[keyof typeof PromotionCodeInvalidReason];

